import { createContext, HTMLProps } from 'react';

export interface AccordionContextState {
  variant: 'primary' | 'secondary' | 'tertiary';
  size: 'small' | 'medium' | 'large' | 'xlarge';
  chevronSide: 'left' | 'right';
  withSeparators: boolean;
  disabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AccordionContext = createContext<AccordionContextState>(undefined!);

export interface AccordionProps extends Omit<HTMLProps<HTMLDivElement>, 'size'> {
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  chevronSide?: 'left' | 'right';
  withSeparators?: boolean;
  disabled?: boolean;
}
